import * as React from 'react';

import { cn, Grid } from '@rematter/ui-web';

import {
  ITEM_ROW_BORDER,
  ITEM_ROW_GRID_BASE,
  ITEM_ROW_SEPARATOR,
} from './constants';

type ItemRowProps = {
  gridTemplate: string;
  children: React.ReactNode;
  className?: string;
  onFocus?: () => void;
};

export const ItemRow: React.FC<ItemRowProps> = ({
  gridTemplate,
  children,
  className,
  onFocus,
}) => (
  <Grid
    className={cn(
      ITEM_ROW_GRID_BASE,
      ITEM_ROW_BORDER,
      ITEM_ROW_SEPARATOR,
      gridTemplate,
      className,
    )}
    onFocus={onFocus}
  >
    {children}
  </Grid>
);
